module.exports = __webpack_public_path__ + "img/cancel_takeoff_enabled.480e11a2.svg";